<template>
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Detalhes do Sumário Executivo</h6>
      <div class="ms-auto">
        <router-link
          to="/projects"
          class="btn btn-sm btn-outline-dark"
          title="Listagem de Sumários Executivos"
        >
          Listagem de Sumários Executivos
        </router-link>
      </div>
    </div>
    <div class="wizard clearfix">
      <div class="steps clearfix">
        <ul role="tablist">
          <li
            v-for="step in steps"
            :key="step.id"
            :class="{
              done: step.done,
              current: step.current,
              disabled: !step.done && !step.current,
            }"
            role="tab"
          >
            <a
              :id="step.id"
              :class="{
                disabled: !step.done && !step.current,
              }"
              role="button"
              @click="changeStep(step.id)"
            >
              <span class="number">{{ step.id }}</span>
              <span class="fs-sm">{{ step.name }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Steps',

  data() {
    return {
      steps: [
        {
          id: 1,
          name: 'Dados básicos',
          done: false,
          current: true,
        },
        {
          id: 2,
          name: 'Colaboradores',
          done: false,
          current: false,
        },
        {
          id: 3,
          name: 'Proponentes',
          done: false,
          current: false,
        },
        {
          id: 4,
          name: 'Parceiros',
          done: false,
          current: false,
        },
        {
          id: 5,
          name: 'Etapas',
          done: false,
          current: false,
        },
        {
          id: 6,
          name: 'Entregas',
          done: false,
          current: false,
        },
        {
          id: 7,
          name: 'Equipe Técnica',
          done: false,
          current: false,
        },
        {
          id: 8,
          name: 'Cronograma',
          done: false,
          current: false,
        },
        {
          id: 9,
          name: 'Recursos',
          done: false,
          current: false,
        },
        {
          id: 10,
          name: 'Comitê',
          done: false,
          current: false,
        },
      ],
    }
  },

  methods: {
    changeStep(stepClicked) {
      this.steps = this.steps.map((step) => {
        return step.id === stepClicked
          ? { ...step, current: true }
          : { ...step, current: false }
      })

      this.$emit('changeStepClicked', stepClicked)
    },
  },
}
</script>
